export default __webpack_public_path__ + "static/media/funeral.95bd350c.png";